export default __webpack_public_path__ + "static/production7r-fcdeb181af35e3cc66c77f044de47452.jpg";